import {
    EDIT_FEEDBACK,
    FETCH_FEEDBACK,
    FETCHING_FEEDBACK_META,
    FETCH_FEEDBACK_META,
    DESTROY_AUCTION,
    DESTROY_FEEDBACK
} from "../actionTypes";

export const fetchFeedback = feedbacks => ({
    type: FETCH_FEEDBACK,
    feedbacks
});

export const editFeedback = feedback => ({
    type: EDIT_FEEDBACK,
    feedback
});

export const fetchingNewsMeta = payload => ({
    type: FETCH_FEEDBACK_META,
    payload
});

export const fetchNewsMeta = payload => ({
    type: FETCHING_FEEDBACK_META,
    payload
});

export const destroyFeedback = key => ({
    type: DESTROY_FEEDBACK,
    key
});